var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _line, _line2, _path12, _path13, _path14, _path15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 614 107.16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2a3344;}.cls-2{fill:#a7a9ac;}.cls-3{fill:none;stroke:#a7a9ac;stroke-miterlimit:10;stroke-width:5px;}.cls-4{fill:#ff7f00;}.cls-5{fill:#939598;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.8,
    y: 25.38,
    width: 11.4,
    height: 58.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.3,66.28c1.1,5.6,5.8,9.6,12.3,9.6,3.5,0,8.6-1.3,11.6-4.4l5.7,6.6c-5.2,5.4-12.9,6.9-18.1,6.9C144,85,134,75.78,134,62.68c0-12.3,9.2-22.3,22.2-22.3,12.5,0,21.8,9.6,21.8,22.3v3.7l-32.7-.1Zm11-17.5c-6.7,0-10.3,4.9-11.1,10.3h22.3c-.6-5.2-4.2-10.3-11.2-10.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.6,56.18v27.6H212.2v-4.5c-1.9,3.5-7.6,5.6-12,5.6-7.8,0-17.4-4-17.4-14.5,0-11.1,9.6-14.5,17.4-14.5,4.4,0,10.1,1.9,12,5.3v-5.4c0-4.2-3.9-7.6-9.2-7.6a18.58,18.58,0,0,0-13.1,5.5l-4.9-6.6c6-6,14.2-7.1,19.5-7.1,10.5.2,19.1,5.2,19.1,16.2m-11.4,10.9c-1.5-2.7-5.5-4.1-8.8-4.1-3.5,0-9.2,1.6-9.2,7.3s5.7,7.3,9.2,7.3c3.2,0,7.3-1.5,8.8-4.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.3,54.58v29.2H231.9V41.48h11.4v4.9a18.09,18.09,0,0,1,13.7-6.1v10.9c-3.7-.9-10.7-.2-13.7,3.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.8,56.18v27.6H341.4v-4.5c-1.9,3.5-7.6,5.6-12,5.6-7.8,0-17.4-4-17.4-14.5,0-11.1,9.6-14.5,17.4-14.5,4.4,0,10.1,1.9,12,5.3v-5.4c0-4.2-3.9-7.6-9.2-7.6a18.58,18.58,0,0,0-13.1,5.5l-4.9-6.6c6-6,14.2-7.1,19.5-7.1,10.5.2,19.1,5.2,19.1,16.2m-11.4,10.9c-1.5-2.7-5.5-4.1-8.8-4.1-3.5,0-9.2,1.6-9.2,7.3s5.7,7.3,9.2,7.3c3.2,0,7.3-1.5,8.8-4.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376,85.28c-9.1,0-12.8-5.4-12.8-12.6V49.88h-7v-8.4h7V29.88h11.4v11.6h8.7v8.4h-8.7V71c0,2.5,1.3,4.7,3.9,4.7a5.09,5.09,0,0,0,4.1-1.6l3.4,8.3c-1.9,1.6-4.4,2.9-10,2.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.8,83.78V57.88c0-5.6-3.3-8.1-7.8-8.1s-7.1,2-9.5,4.8v29.2H391.1V25.38h11.4v21c2.5-2.9,6.9-6.1,14.4-6.1,9.2,0,14.3,5.9,14.3,14.6v28.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.5,85.58c-17.4,0-31.5-12.6-31.5-30.9s14-31,31.5-31c12.5,0,20.8,6,25.1,13l-10,6.1a17.79,17.79,0,0,0-15.1-8.6c-10.3,0-18.5,7.9-18.5,20.5s8.2,20.4,18.5,20.4a20.52,20.52,0,0,0,12.4-4.2v-8.8H469.8v-9.6h26.7v22.3c-5.8,6.7-14.7,10.8-25,10.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.8,61.68H516v22.1H503.4V25.38h27.4c11.5,0,19.7,8,19.7,18.2s-7.5,18.1-19.7,18.1m-1.1-26.5H516v16.9h13.7c3.8,0,7.9-3.6,7.9-8.5a8.36,8.36,0,0,0-7.9-8.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M577.9,85.58c-12.6,0-19.9-5.5-23.9-9.8l7.4-8.5c1.9,2.7,8.5,8.4,16,8.4,6.4,0,11.7-2.5,11.7-7.6,0-4.2-4.2-6.8-13.3-8.3-16.1-2.6-20.7-10-20.7-18.1,0-9.5,9.5-18,22.8-18,12.2,0,19.2,4.5,23.1,8.8l-7.3,7.6c-3-3.6-9.2-6.5-14.8-6.5-5.2,0-10,2.2-10,7.3,0,3.9,3.5,5.7,11.6,7.1,13.5,2.3,22.3,7,22.3,18.8,0,12.5-11.4,18.8-24.9,18.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.4,84.58c-12.9,0-22.5-9.5-22.5-22.3S80.5,40,93.4,40c7.4,0,13.1,2.7,17.4,7.7l-7.4,6.7c-2.5-3.4-5.6-5.3-9.6-5.3-6.6,0-11.3,5.4-11.3,13.1s4.7,13.1,11.3,13.1c3.9,0,7-1.8,9.6-5.2l7.4,6.7a21.7,21.7,0,0,1-17.4,7.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.1,84.58c-5.8,0-10.5-2.2-12.9-6.4v22.2H264.8V41.18h11.4v5.3c2.3-4.2,7.1-6.5,12.9-6.5,10.7,0,19.2,8.3,19.2,22.3s-8.5,22.3-19.2,22.3m-3.6-35.5c-3.9,0-7.5,1.7-9.3,4.4V71c1.8,2.8,5.3,4.5,9.3,4.5,6.5,0,11-5.5,11-13.2s-4.5-13.2-11-13.2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.6,
    y1: 83.38,
    x2: 29.7,
    y2: 70.48
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.4,
    y1: 29.98,
    x2: 31,
    y2: 50.38
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.9,18.88A16.6,16.6,0,1,1,61.3,2.28a16.56,16.56,0,0,1,16.6,16.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.2,60A15.25,15.25,0,1,1,20,44.68,15.3,15.3,0,0,1,35.2,60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.3,91.48a12.8,12.8,0,1,1-12.8-12.8,12.82,12.82,0,0,1,12.8,12.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M605,24.88h0a2.65,2.65,0,0,1,2.6-2.6,2.58,2.58,0,0,1,2.6,2.6h0a2.65,2.65,0,0,1-2.6,2.6A2.58,2.58,0,0,1,605,24.88Zm4.9-.1h0a2.26,2.26,0,0,0-2.3-2.3,2.33,2.33,0,0,0-2.3,2.3h0a2.26,2.26,0,0,0,2.3,2.3A2.2,2.2,0,0,0,609.9,24.78Zm-3.3-1.3h1.2c.6,0,1,.3,1,.8a.87.87,0,0,1-.6.8l.7,1h-.6l-.6-.9h-.6v.9h-.5v-2.6Zm1.1,1.3a.46.46,0,0,0,.5-.4c0-.3-.2-.4-.5-.4h-.6v.9l.6-.1Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.9ba88b3f.svg";
export { ForwardRef as ReactComponent };